export const ASSET_PERSISTENCE_STORAGE_KEY = "critter.rememberUploadedAssets";

const ASSET_PERSISTENCE_CHANGED_EVENT = "critter-asset-persistence-changed";

export function isAssetPersistenceEnabled(): boolean {
  try {
    return globalThis.localStorage?.getItem(ASSET_PERSISTENCE_STORAGE_KEY) !== "false";
  } catch {
    return true;
  }
}

export function setAssetPersistenceEnabled(enabled: boolean): void {
  try {
    if (enabled) {
      globalThis.localStorage?.removeItem(ASSET_PERSISTENCE_STORAGE_KEY);
    } else {
      globalThis.localStorage?.setItem(ASSET_PERSISTENCE_STORAGE_KEY, "false");
    }
  } catch {
    // Storage can be unavailable; callers still keep the in-memory state for this session.
  }

  try {
    globalThis.dispatchEvent(
      new CustomEvent(ASSET_PERSISTENCE_CHANGED_EVENT, { detail: { enabled } })
    );
  } catch {
    // Non-browser contexts do not need change notifications.
  }
}

export function subscribeAssetPersistencePreference(
  listener: (enabled: boolean) => void
): () => void {
  const handlePreferenceChanged = (event: Event) => {
    const customEvent = event as CustomEvent<{ enabled?: boolean }>;
    listener(customEvent.detail?.enabled ?? isAssetPersistenceEnabled());
  };
  const handleStorage = (event: StorageEvent) => {
    if (event.key === ASSET_PERSISTENCE_STORAGE_KEY) {
      listener(isAssetPersistenceEnabled());
    }
  };

  globalThis.addEventListener?.(ASSET_PERSISTENCE_CHANGED_EVENT, handlePreferenceChanged);
  globalThis.addEventListener?.("storage", handleStorage);

  return () => {
    globalThis.removeEventListener?.(ASSET_PERSISTENCE_CHANGED_EVENT, handlePreferenceChanged);
    globalThis.removeEventListener?.("storage", handleStorage);
  };
}
